import React, {  useRef, useContext } from 'react';
import {  Button, Box, Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import extraSymptomsIndex from '../../../../symptom lists/symptomsExtraInfo/extraSymptomsIndex';
import symptomHandler from '../../../../utilities/symptomHandler';
import RadioButton from './radiobutton';
import CheckboxGroup from './checkboxgroup'
import InputField from './inputfield';
import { SymptomDetailsContext } from '../../../../utilities/context.js'
import TextArea from './textarea';
import DropDown from './dropdown';




function ModalSymptomForm(props){

const {extraSymptomDetails} = useContext(SymptomDetailsContext) 

const symptomGroup=props.symptomObject["symptomQuestionGroup"]
 const extraSymptoms = extraSymptomsIndex[symptomGroup]

 const initialValues= symptomHandler.initialValuesBuilder(extraSymptoms)
   initialValues["symptom"]=props.symptomObject["symptomText"]
   initialValues["symptomGroup"]=props.symptomObject["symptomQuestionGroup"]

const formValues=useRef()

 const validationSchema={}
 
 const onSubmit=(values)=>
   {
    extraSymptomDetails.push(values)
    props.handleClose()
   }


const onChange=(symptom,element)=>{;
initialValues[symptom]=element}

 let formQuestions=extraSymptoms.map((symptom, index)=>
    { 
      symptom["name"]=symptom.label.replaceAll(" ","_")
    

 switch(symptom["controlType"])
    {
      case "radio button":
        symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "checkbox")
       return (<Grid item xs={6} sm={4} key={index}> <RadioButton  symptom={symptom}  onChange={onChange} key={0} /> </Grid>)

      case "number":
      return (<Grid item xs={6} sm={4} key={index}> <InputField type={"number"} symptom ={symptom} min={"0"} key={0} /> </Grid>)

      case "text":
       return (<Grid item xs={5} sm={3} key={index}> <InputField type={"text"} symptom ={symptom}  key={0} /> </Grid>)

      
      case "text area":
      return (<Grid item xs={12} sm={6} key={index}> <TextArea  symptom ={symptom}  key={0} /> </Grid>)
      
      case "dropdown": 
      symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "dropdown")
      return(<Grid item xs={5} sm={3} key={index}> <DropDown  symptom ={symptom}  key={0} /> </Grid>)

      case "checkbox group":
        let gridSize = 4
        if (symptom.options.length >5)
          {gridSize = 8} 
        symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "checkbox")
        return (<Grid item  xs={gridSize} key={index}> <CheckboxGroup symptom={symptom}  key={0} /> </Grid>)

        case "checkbox group extra wide":
        symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "checkbox")
        return (<Grid item  xs={12} key={index}> <CheckboxGroup symptom={symptom}  key={0} /> </Grid>)


      case "date":
      return (<Grid item xs={5} sm={4} key={index}> <InputField type={"date"} symptom ={symptom}  key={0} /> </Grid>)

      default:{return(<></>)}
 }

})

 
return(

        <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        //validationSchema={validationSchema}
        innerRef={formValues}
        >


       <Form>
           
        <Box>
        <Grid container >
        {formQuestions}
         <Button sx={{ m: 1 }} variant='contained' size="small" type='submit'>Submit</Button>
       </Grid> 
       </Box>
       
        
        </Form>
      </Formik>

)



}
export default ModalSymptomForm